import React, {useMemo} from 'react';
import {FormGroup, InputGroup} from '@blueprintjs/core';

import {Integration} from '../../../models';
import VoidElement from '../../VoidElement';

interface IntegrationFormProps {
  values: any;
  onChange: (key: string, value: any) => void;
  integration?: Integration;
  disabled?: boolean;
}

export const IntegrationForm = ({
  values,
  onChange,
  integration,
  disabled = false,
}: IntegrationFormProps) => {
  if (!integration) {
    return null;
  }
  const {form_inputs = null} = integration?.config_json || {};

  if (!form_inputs) {
    return null;
  }

  const _onChange = (key: string) => (event: any) => {
    const value = event.target.value;
    onChange(key, value);
  }

  return (
    <div className="integration-form">
      {
        form_inputs
          .filter((input: any) => !!input.name)
          .map((input: any, index: any) => {
            const name = input.name;

            let defaultValue = input.defaultValue || '';
            if (values?.hasOwnProperty(name)) {
              defaultValue = values[name];
            }

            return (
              <VoidElement
                key={integration.uid + '_' + index}
              >
                <FormGroup inline={true} label={input.name}>
                  <InputGroup
                    defaultValue={defaultValue}
                    onChange={_onChange(name)}
                    disabled={disabled}
                  />
                </FormGroup>
              </VoidElement>
            )
          })
      }
    </div>
  );
};
